import type { RoleIds } from "models/Role.model";
import { isOrgAdminRole } from "utils/roleUtils";

export const canShareSecureLinkForCompute = ({
  activeOrgRole,
  currentUserId,
  creatorUserId,
}: {
  activeOrgRole?: RoleIds;
  currentUserId?: string;
  creatorUserId?: string;
}) =>
  isOrgAdminRole(activeOrgRole) ||
  (Boolean(currentUserId) && currentUserId === creatorUserId);
